document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".collection-tag-filters");
  const list = container?.querySelector(".tag-filter-list");
  if (!list || list.scrollWidth <= list.clientWidth) return;
  const leftArrow = document.createElement("span");
  const rightArrow = document.createElement("span");
  leftArrow.className = "scroll-arrow left disabled";
  rightArrow.className = "scroll-arrow right";
  leftArrow.textContent = "◀";
  rightArrow.textContent = "▶";
  container.appendChild(leftArrow);
  container.appendChild(rightArrow);
  const updateArrows = () => {
    leftArrow.classList.toggle("disabled", list.scrollLeft <= 0);
    rightArrow.classList.toggle(
      "disabled",
      list.scrollLeft + list.clientWidth >= list.scrollWidth - 1
    );
  };
  leftArrow.addEventListener("click", () => {
    list.scrollBy({ left: -200, behavior: "smooth" });
  });
  rightArrow.addEventListener("click", () => {
    list.scrollBy({ left: 200, behavior: "smooth" });
  });
  list.addEventListener("scroll", updateArrows);
  updateArrows();
});

document.addEventListener('click', function (e) {
  const overlay = e.target.closest('.video-play-overlay');
  if (!overlay) return;
  const wrapper = overlay.closest('.collection-video-wrapper');
  const video = wrapper.querySelector('video');
  overlay.style.display = 'none';
  video.controls = true;
  video.play();
});